(() => {
  'use strict';

  const ROW_SELECTOR = '[data-miniami-checkbox-row]';
  const INPUT_SELECTOR = 'input[type="checkbox"]';

  function sync(row) {
    const input = row.querySelector(INPUT_SELECTOR);
    if (!input) return;
    row.classList.toggle('mn-check--on', input.checked);
    row.classList.toggle('mn-check--disabled', input.disabled);
    row.setAttribute('aria-checked', String(input.checked));
  }

  function unbind(row) {
    const input = row.querySelector(INPUT_SELECTOR);
    if (input && row._miniamiCheckboxChange) {
      input.removeEventListener('change', row._miniamiCheckboxChange);
    }
    delete row._miniamiCheckboxChange;
    row.removeAttribute('data-miniami-checkbox-bound');
  }

  function bind(root = document) {
    const rows = root.querySelectorAll?.(ROW_SELECTOR) || [];
    rows.forEach((row) => {
      if (row.dataset.miniamiCheckboxBound === 'true') {
        sync(row);
        return;
      }
      const input = row.querySelector(INPUT_SELECTOR);
      if (!input) return;
      const change = () => sync(row);
      row._miniamiCheckboxChange = change;
      row.dataset.miniamiCheckboxBound = 'true';
      input.addEventListener('change', change);
      sync(row);
    });
  }

  function bindEditorSection(event) {
    bind(event?.target || document);
  }

  function unbindEditorSection(event) {
    const root = event?.target || document;
    const rows = root.matches?.(ROW_SELECTOR) ? [root] : root.querySelectorAll?.(ROW_SELECTOR) || [];
    rows.forEach(unbind);
  }

  document.addEventListener('shopify:section:load', bindEditorSection);
  document.addEventListener('shopify:section:reorder', bindEditorSection);
  document.addEventListener('shopify:section:unload', unbindEditorSection);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => bind(), { once: true });
  } else {
    bind();
  }
})();
